import React, { useEffect, useState } from 'react'
import SearchIcon from '@material-ui/icons/Search'
import StyledIconButton from '../../Form/StyledIconButton'

export const SearchInputUnstyled = props => {
  const [text, setText] = useState('')

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const tableSearch = urlParams.get('tableSearch')
    if (tableSearch) {
      setText(tableSearch)
      props.searchHandler(tableSearch)
    }
  }, [])

  useEffect(() => {
    if (props.reset && props.setReset) {
      setText('')
      props.setReset(false)
    }
  }, [props.reset])

  return (
    <div className={props.className}>
      <input
        onChange={event => {
          setText(event.target.value)
        }}
        value={text}
        onKeyUp={event =>
          event.keyCode === 13 || !event.target.value
            ? props.searchHandler(text)
            : ''
        }
        placeholder={
          props.placeholder ? props.placeholder : 'Search client or campaign...'
        }
      >
        {props.children}
      </input>
      <StyledIconButton
        className="search-icon"
        onClick={() => {
          props.searchHandler(text)
        }}
      >
        <SearchIcon />
      </StyledIconButton>
    </div>
  )
}
